/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_ActiveContractsSummaryResponse } from '../models/billing_ActiveContractsSummaryResponse';
import type { billing_BackfillPayersResponse } from '../models/billing_BackfillPayersResponse';
import type { billing_CalculateContractDatesRequest } from '../models/billing_CalculateContractDatesRequest';
import type { billing_CancelContractVersionRequest } from '../models/billing_CancelContractVersionRequest';
import type { billing_ContractAuditHistoryResponse } from '../models/billing_ContractAuditHistoryResponse';
import type { billing_ContractAuditRecord } from '../models/billing_ContractAuditRecord';
import type { billing_ContractListResponse } from '../models/billing_ContractListResponse';
import type { billing_ContractResponse } from '../models/billing_ContractResponse';
import type { billing_ContractVersionListResponse } from '../models/billing_ContractVersionListResponse';
import type { billing_ContractVersionResponse } from '../models/billing_ContractVersionResponse';
import type { billing_CreateContractRequest } from '../models/billing_CreateContractRequest';
import type { billing_ExpiringBFListResponse } from '../models/billing_ExpiringBFListResponse';
import type { billing_PayerRequest } from '../models/billing_PayerRequest';
import type { billing_ScheduleChangeRequest } from '../models/billing_ScheduleChangeRequest';
import type { billing_SubsidyAmendApplyRequest } from '../models/billing_SubsidyAmendApplyRequest';
import type { billing_SubsidyAmendPreviewResponse } from '../models/billing_SubsidyAmendPreviewResponse';
import type { billing_SubsidyAmendResultResponse } from '../models/billing_SubsidyAmendResultResponse';
import type { billing_TerminateContractRequest } from '../models/billing_TerminateContractRequest';
import type { billing_TerminateGroupRequest } from '../models/billing_TerminateGroupRequest';
import type { billing_UpdateContractRequest } from '../models/billing_UpdateContractRequest';
import type { billing_UpdateContractVersionPeriodRequest } from '../models/billing_UpdateContractVersionPeriodRequest';
import type { billing_VersionSplitResponse } from '../models/billing_VersionSplitResponse';
import type { contracts_audit_ContractGroupAuditHistoryResponse } from '../models/contracts_audit_ContractGroupAuditHistoryResponse';
import type { contracts_audit_ContractGroupAuditRecord } from '../models/contracts_audit_ContractGroupAuditRecord';
import type { documents_DocumentDownloadResponse } from '../models/documents_DocumentDownloadResponse';
import type { documents_ListSubsidyDocumentsResponse } from '../models/documents_ListSubsidyDocumentsResponse';
import type { documents_SubsidyDocumentResponse } from '../models/documents_SubsidyDocumentResponse';
import type { documents_UploadSubsidyDocumentRequest } from '../models/documents_UploadSubsidyDocumentRequest';
import type { services_ContractDateCalculationResponse } from '../models/services_ContractDateCalculationResponse';
import type { shared_SuccessResponse } from '../models/shared_SuccessResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractsService {
    /**
     * List contracts with filters
     * List contracts with optional filters for status (comma-separated), child, search, and sorting
     * @param status Filter by effective status - comma-separated values (IN_EFFECT, UPCOMING, EXPIRED, CANCELLED, TERMINATED - case insensitive, legacy: ACTIVE→IN_EFFECT, ARCHIVED→EXPIRED)
     * @param childId Filter by child ID
     * @param search Search term to filter by contract number, child name, or notes
     * @param sortBy Column to sort by (contract_number, child_name, start_date, end_date, status, created_at)
     * @param sortOrder Sort direction (asc, desc)
     * @param limit Pagination limit (max 100)
     * @param offset Pagination offset
     * @param labelIds Filter by comma-separated label definition IDs
     * @param subsidised Filter by subsidised flag (true or false)
     * @param subsidyDecisionPending Filter by contract groups where any non-deleted version waits for a subsidy decision (true) or none does (false)
     * @param hasStaffNotes Filter by contract groups where any non-deleted version has a notes line a person wrote (true) or none does (false); system-written lines do not count
     * @param startDateFrom Filter: start_date on or after this date (YYYY-MM-DD)
     * @param startDateTo Filter: start_date on or before this date (YYYY-MM-DD)
     * @param endDateFrom Filter: end_date on or after this date (YYYY-MM-DD)
     * @param endDateTo Filter: end_date on or before this date (YYYY-MM-DD)
     * @param createdFrom Filter: created_at on or after this date (YYYY-MM-DD)
     * @param createdTo Filter: created_at on or before this date (YYYY-MM-DD)
     * @returns billing_ContractListResponse OK
     * @throws ApiError
     */
    public static getApiV1Contracts(
        status?: string,
        childId?: string,
        search?: string,
        sortBy: string = 'created_at',
        sortOrder: string = 'desc',
        limit?: number,
        offset?: number,
        labelIds?: string,
        subsidised?: boolean,
        subsidyDecisionPending?: boolean,
        hasStaffNotes?: boolean,
        startDateFrom?: string,
        startDateTo?: string,
        endDateFrom?: string,
        endDateTo?: string,
        createdFrom?: string,
        createdTo?: string,
    ): CancelablePromise<billing_ContractListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts',
            query: {
                'status': status,
                'child_id': childId,
                'search': search,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'limit': limit,
                'offset': offset,
                'label_ids': labelIds,
                'subsidised': subsidised,
                'subsidy_decision_pending': subsidyDecisionPending,
                'has_staff_notes': hasStaffNotes,
                'start_date_from': startDateFrom,
                'start_date_to': startDateTo,
                'end_date_from': endDateFrom,
                'end_date_to': endDateTo,
                'created_from': createdFrom,
                'created_to': createdTo,
            },
            errors: {
                400: `Invalid query parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to list contracts`,
            },
        });
    }
    /**
     * Create a new contract
     * Create a new contract with payers and service pattern
     * @param request Contract details
     * @returns billing_ContractResponse Created (may include overlap_warning when an overlap is detected, non-blocking)
     * @throws ApiError
     */
    public static postApiV1Contracts(
        request: billing_CreateContractRequest,
    ): CancelablePromise<billing_ContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts',
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                500: `Failed to create contract`,
            },
        });
    }
    /**
     * Delete a contract
     * Soft delete a contract (only upcoming contracts can be deleted)
     * @param id Contract ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Contracts(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing contract ID`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                409: `Only upcoming contracts can be deleted`,
                500: `Failed to delete contract`,
            },
        });
    }
    /**
     * Get a contract by ID
     * Get a contract by ID with payers
     * @param id Contract ID
     * @returns billing_ContractResponse OK
     * @throws ApiError
     */
    public static getApiV1Contracts1(
        id: string,
    ): CancelablePromise<billing_ContractResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing contract ID`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                500: `Failed to get contract`,
            },
        });
    }
    /**
     * Update a contract
     * Update an existing contract. Contract duration (start/end) can be changed as long as no non-cancelled invoice covers a period that would be orphaned, and the contract group has a single version; otherwise use the version editor.
     * @param id Contract ID
     * @param request Contract updates
     * @returns billing_ContractResponse OK
     * @throws ApiError
     */
    public static putApiV1Contracts(
        id: string,
        request: billing_UpdateContractRequest,
    ): CancelablePromise<billing_ContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contracts/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                422: `Duration change blocked (existing invoice, multiple versions, or validation)`,
                500: `Failed to update contract`,
            },
        });
    }
    /**
     * Get active versions for a billing period
     * Get all active contract versions for a specific billing period
     * @param id Contract ID
     * @param start Start date (YYYY-MM-DD)
     * @param end End date (YYYY-MM-DD)
     * @returns billing_ContractVersionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsActiveVersions(
        id: string,
        start?: string,
        end?: string,
    ): CancelablePromise<billing_ContractVersionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/active-versions',
            path: {
                'id': id,
            },
            query: {
                'start': start,
                'end': end,
            },
            errors: {
                400: `Missing contract ID or invalid dates`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                500: `Failed to get active versions`,
            },
        });
    }
    /**
     * Get audit history for a contract
     * Get paginated audit history for a specific contract
     * @param id Contract ID
     * @param page Page number (default: 1)
     * @param limit Page size (default: 20, max: 100)
     * @returns billing_ContractAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsAudit(
        id: string,
        page?: number,
        limit?: number,
    ): CancelablePromise<billing_ContractAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/audit',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get audit history`,
            },
        });
    }
    /**
     * Get field change history for a contract
     * Get the history of changes to a specific field
     * @param id Contract ID
     * @param field Field name
     * @returns billing_ContractAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1ContractsAuditField(
        id: string,
        field: string,
    ): CancelablePromise<Array<billing_ContractAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/audit/field/{field}',
            path: {
                'id': id,
                'field': field,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                404: `Unknown field`,
                500: `Failed to get field history`,
            },
        });
    }
    /**
     * Get recent changes for a contract
     * Get the last 10 changes to a contract
     * @param id Contract ID
     * @returns billing_ContractAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1ContractsAuditRecent(
        id: string,
    ): CancelablePromise<Array<billing_ContractAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/audit/recent',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing contract ID`,
                403: `Organization ID not found in token`,
                500: `Failed to get recent changes`,
            },
        });
    }
    /**
     * Get change history for one contract version
     * Get paginated audit history for a single contract version
     * @param id Contract ID
     * @param page Page number
     * @param limit Page size
     * @returns contracts_audit_ContractGroupAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsHistory(
        id: string,
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<contracts_audit_ContractGroupAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                500: `Failed to get audit history`,
            },
        });
    }
    /**
     * Get one field's change history on one contract version
     * Get the history of changes to a single whitelisted contract field
     * @param id Contract ID
     * @param field Field name
     * @returns contracts_audit_ContractGroupAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1ContractsHistoryField(
        id: string,
        field: string,
    ): CancelablePromise<Array<contracts_audit_ContractGroupAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/history/field/{field}',
            path: {
                'id': id,
                'field': field,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Unknown field`,
                500: `Failed to get field history`,
            },
        });
    }
    /**
     * Update contract payers
     * Update payers for a contract (validates percentages sum to 100%)
     * @param id Contract ID
     * @param request Payers list
     * @returns billing_ContractResponse OK
     * @throws ApiError
     */
    public static putApiV1ContractsPayers(
        id: string,
        request: Array<billing_PayerRequest>,
    ): CancelablePromise<billing_ContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contracts/{id}/payers',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid or missing contract ID`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                422: `Invalid request or percentages don't sum to 100%`,
                500: `Failed to update payers`,
            },
        });
    }
    /**
     * Schedule a contract change
     * Schedule a future change to a contract that will create a new version
     * @param id Contract ID
     * @param request Change details
     * @returns billing_VersionSplitResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractsScheduleChange(
        id: string,
        request: billing_ScheduleChangeRequest,
    ): CancelablePromise<billing_VersionSplitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/{id}/schedule-change',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                422: `Change blocked by a non-cancelled invoice covering the affected period, or dated outside the selected version (code SCHEDULE_CHANGE_*)`,
                500: `Failed to schedule change`,
            },
        });
    }
    /**
     * Apply a subsidy office/amount change to billed invoices
     * Atomically, for each selected billed invoice: moves the office's received payment(s) to the new office, re-points and re-values the subsidy line in place (same invoice number + QR reference), re-applies the moved money, and recomputes. Reversible.
     * @param id Contract ID
     * @param request Invoices + confirmed office shares
     * @returns billing_SubsidyAmendResultResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractsSubsidyAmendApply(
        id: string,
        request: billing_SubsidyAmendApplyRequest,
    ): CancelablePromise<billing_SubsidyAmendResultResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/{id}/subsidy-amend/apply',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Preview applying a subsidy change to billed invoices
     * Read-only. Lists the contract's billed invoices whose subsidy office / share still diverges from the contract's current setup, with the engine-proposed new share per invoice. Makes no DB writes.
     * @param id Contract ID
     * @returns billing_SubsidyAmendPreviewResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsSubsidyAmendPreview(
        id: string,
    ): CancelablePromise<billing_SubsidyAmendPreviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/subsidy-amend/preview',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List the subsidy documents of a contract version
     * The documents of the version and of its earlier versions in the contract group (BF and SBU confirmations, signed Finanzierungsantrag, Elternvereinbarung, city decision, KmbB papers), newest version first (#2002).
     * @param id Contract version ID
     * @returns documents_ListSubsidyDocumentsResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsSubsidyDocuments(
        id: string,
    ): CancelablePromise<documents_ListSubsidyDocumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/subsidy-documents',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contract id`,
                404: `Contract not found`,
                500: `Failed to list subsidy documents`,
            },
        });
    }
    /**
     * Attach a subsidy document to a contract version
     * Links a confirmed upload (purpose "document"; PDF, JPEG or PNG; magic bytes checked at confirm) to the contract version. Validity dates only on bf_confirmation, sbu_confirmation, kmbb_fachstelle and kmbb_standortgespraech (#2002).
     * @param id Contract version ID
     * @param request Document
     * @returns documents_SubsidyDocumentResponse Created
     * @throws ApiError
     */
    public static postApiV1ContractsSubsidyDocuments(
        id: string,
        request: documents_UploadSubsidyDocumentRequest,
    ): CancelablePromise<documents_SubsidyDocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/{id}/subsidy-documents',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request: SUBSIDY_DOCUMENT_CATEGORY_INVALID, SUBSIDY_DOCUMENT_VALIDITY_NOT_ALLOWED, SUBSIDY_DOCUMENT_VALIDITY_ORDER, SUBSIDY_DOCUMENT_FILE_TYPE`,
                404: `Contract not found`,
                500: `Failed to upload subsidy document`,
            },
        });
    }
    /**
     * Delete a subsidy document
     * Soft-deletes the document. It must belong to the version or an earlier version of its group.
     * @param id Contract version ID
     * @param documentId Document ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ContractsSubsidyDocuments(
        id: string,
        documentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contracts/{id}/subsidy-documents/{documentId}',
            path: {
                'id': id,
                'documentId': documentId,
            },
            errors: {
                400: `Invalid id`,
                404: `Document not found`,
                500: `Failed to delete subsidy document`,
            },
        });
    }
    /**
     * Download a subsidy document (audited)
     * Issues a fresh presigned download URL and records a `download` access-log row. The document must belong to the version or an earlier version of its group.
     * @param id Contract version ID
     * @param documentId Document ID
     * @returns documents_DocumentDownloadResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsSubsidyDocumentsDownload(
        id: string,
        documentId: string,
    ): CancelablePromise<documents_DocumentDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/{id}/subsidy-documents/{documentId}/download',
            path: {
                'id': id,
                'documentId': documentId,
            },
            errors: {
                400: `Invalid id`,
                404: `Document not found`,
                500: `Failed to download subsidy document`,
            },
        });
    }
    /**
     * Terminate a contract
     * Terminate an active or suspended contract
     * @param id Contract ID
     * @param request Termination details
     * @returns billing_ContractResponse OK
     * @throws ApiError
     */
    public static putApiV1ContractsTerminate(
        id: string,
        request: billing_TerminateContractRequest,
    ): CancelablePromise<billing_ContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contracts/{id}/terminate',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or missing/invalid contract ID`,
                403: `Organization ID not found in token`,
                404: `Contract not found`,
                409: `Can only terminate active or suspended contracts`,
                500: `Failed to terminate contract`,
            },
        });
    }
    /**
     * Get active contracts for billing period
     * Get all active contracts for a specific billing period
     * @param billingDate Billing date (ISO 8601) - defaults to current date
     * @returns billing_ContractListResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsActive(
        billingDate?: string,
    ): CancelablePromise<billing_ContractListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/active',
            query: {
                'billing_date': billingDate,
            },
            errors: {
                400: `Invalid billing date`,
                403: `Organization ID not found in token`,
                500: `Failed to get active contracts`,
            },
        });
    }
    /**
     * Get active-contract counts for a billing date
     * Returns COUNT(*) active contracts and COUNT(DISTINCT child_id) active children for a point-in-time. Lightweight companion to /contracts/active for the analytics Children KPIs — it does NOT resolve child names, avoiding the per-child fetch fan-out.
     * @param billingDate Billing date (ISO 8601) - defaults to current date
     * @returns billing_ActiveContractsSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsActiveSummary(
        billingDate?: string,
    ): CancelablePromise<billing_ActiveContractsSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/active/summary',
            query: {
                'billing_date': billingDate,
            },
            errors: {
                400: `Invalid billing date`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to get active contracts summary`,
            },
        });
    }
    /**
     * List contracts whose Beitragsfaktor or SBU expires within N days
     * Returns live subsidised contract versions whose Beitragsfaktor valid-until date falls within the next `days` days. Used by the admin dashboard widget (issue #567) and the management app. `include_sbu=true` adds one row per version for the SBU valid-until date; `include_kmbb=true` adds one row per KmbB version for its protocol date (#2007); `include_expired=true` adds documents whose date has passed (negative days_remaining, sorted first). A renewal (a later version with a later date) removes the row (#2004).
     * @param days Days ahead to scan (1-365, default 60)
     * @param includeSbu Add SBU rows (default false)
     * @param includeExpired Add expired documents (default false)
     * @param includeKmbb Add KmbB protocol rows (default false)
     * @returns billing_ExpiringBFListResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsBfExpiring(
        days?: number,
        includeSbu?: boolean,
        includeExpired?: boolean,
        includeKmbb?: boolean,
    ): CancelablePromise<billing_ExpiringBFListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/bf-expiring',
            query: {
                'days': days,
                'include_sbu': includeSbu,
                'include_expired': includeExpired,
                'include_kmbb': includeKmbb,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Calculate contract start and end dates
     * Calculate optimal contract dates based on child age and kindergarten enrollment.
     *
     * Date Semantics:
     * - All dates are returned as calendar date-only strings in YYYY-MM-DD format (e.g., "2024-01-15")
     * - No time or timezone information is included; dates represent calendar days
     * - startDate: First calendar day the child is eligible for enrollment (birthdate + minimum age in months; no month rounding), inclusive
     * - endDate: Last calendar day of the daycare contract before kindergarten starts, inclusive
     *
     * Birthdate Support:
     * - Supports future birthdates for unborn children (contract planning)
     * - Supports historical birthdates for data imports of past contracts
     *
     * Validation:
     * - Returns 404 if childcare location is not found
     * - Returns 422 if canton is not configured for the childcare location
     * - Returns 422 if organization age settings are invalid (e.g., daycare_min_age_months >= kindergarten_min_age_months)
     * - Returns 422 if kindergarten enrollment data is missing for the childcare's canton
     * @param request Contract calculation request
     * @returns services_ContractDateCalculationResponse Calculated dates with metadata
     * @throws ApiError
     */
    public static calculateContractDates(
        request: billing_CalculateContractDatesRequest,
    ): CancelablePromise<services_ContractDateCalculationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/calculate-dates',
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                401: `Unauthorized - authentication required or invalid token`,
                403: `Organization ID not found in token`,
                404: `Childcare location or organization not found`,
                422: `Domain validation failed (e.g., missing canton configuration, invalid age configuration, missing kindergarten data)`,
                500: `Failed to calculate contract dates`,
            },
        });
    }
    /**
     * Get change history for a whole contract version chain
     * Get paginated audit history for every version of a contract group, newest first, including payer changes
     * @param groupId Contract group ID
     * @param limit Page size
     * @param offset Row offset
     * @returns contracts_audit_ContractGroupAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsGroupHistory(
        groupId: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<contracts_audit_ContractGroupAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/group/{groupId}/history',
            path: {
                'groupId': groupId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Contract group not found`,
                500: `Failed to get audit history`,
            },
        });
    }
    /**
     * Terminate all versions in a contract group
     * Terminate all active and future versions in a contract group
     * @param groupId Contract Group ID
     * @param request Termination details
     * @returns shared_SuccessResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractsGroupTerminate(
        groupId: string,
        request: billing_TerminateGroupRequest,
    ): CancelablePromise<shared_SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/group/{groupId}/terminate',
            path: {
                'groupId': groupId,
            },
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                500: `Failed to terminate contract group`,
            },
        });
    }
    /**
     * Get all versions for a contract group
     * Get all contract versions belonging to the same contract group
     * @param groupId Contract Group ID
     * @returns billing_ContractVersionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ContractsGroupVersions(
        groupId: string,
    ): CancelablePromise<billing_ContractVersionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contracts/group/{groupId}/versions',
            path: {
                'groupId': groupId,
            },
            errors: {
                400: `Missing contract group ID`,
                403: `Organization ID not found in token`,
                500: `Failed to get contract versions`,
            },
        });
    }
    /**
     * Backfill missing contract payers
     * For each version with zero payers, clone payers from nearest prior version in the same group
     * @param dryRun If true, only report without writing (default: true when apply is not set)
     * @param apply If true, apply writes and override dry_run (default: false)
     * @returns billing_BackfillPayersResponse Backfill summary
     * @throws ApiError
     */
    public static postApiV1ContractsPayersBackfill(
        dryRun: boolean = true,
        apply: boolean = false,
    ): CancelablePromise<billing_BackfillPayersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/payers/backfill',
            query: {
                'dry_run': dryRun,
                'apply': apply,
            },
            errors: {
                401: `Unauthenticated`,
                403: `Unauthorized`,
                500: `Backfill failed`,
            },
        });
    }
    /**
     * Delete a contract version
     * Soft-delete a single contract version, removing it from the timeline. Works on archived versions. If a non-cancelled invoice covers the version's period the delete is blocked (422) so the caller can cancel those invoices and retry.
     * @param versionId Contract Version ID
     * @returns billing_ContractVersionResponse OK
     * @throws ApiError
     */
    public static deleteApiV1ContractsVersions(
        versionId: string,
    ): CancelablePromise<billing_ContractVersionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contracts/versions/{versionId}',
            path: {
                'versionId': versionId,
            },
            errors: {
                400: `Invalid request`,
                401: `Unauthenticated`,
                403: `Organization ID or user ID not found in token`,
                404: `Version not found`,
                422: `Deletion blocked by a non-cancelled invoice covering the version's period`,
                500: `Deletion failed`,
            },
        });
    }
    /**
     * Cancel an upcoming contract version
     * Cancel an upcoming contract version by merging it into an adjacent version
     * @param versionId Contract Version ID
     * @param request Cancellation payload
     * @returns billing_ContractVersionResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractsVersionsCancel(
        versionId: string,
        request: billing_CancelContractVersionRequest,
    ): CancelablePromise<billing_ContractVersionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/versions/{versionId}/cancel',
            path: {
                'versionId': versionId,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                403: `Unauthorized`,
                404: `Version not found`,
                422: `Cancellation blocked by a non-cancelled invoice covering the version's period`,
                500: `Cancellation failed`,
            },
        });
    }
    /**
     * Update contract version period
     * Adjust the start/end dates of a contract version while keeping the timeline contiguous
     * @param versionId Contract Version ID
     * @param request Update payload
     * @returns billing_ContractVersionResponse OK
     * @throws ApiError
     */
    public static patchApiV1ContractsVersionsPeriod(
        versionId: string,
        request: billing_UpdateContractVersionPeriodRequest,
    ): CancelablePromise<billing_ContractVersionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/contracts/versions/{versionId}/period',
            path: {
                'versionId': versionId,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                403: `Unauthorized`,
                404: `Version not found`,
                422: `Adjustment blocked by a non-cancelled invoice covering the affected period`,
                500: `Update failed`,
            },
        });
    }
    /**
     * Undo a scheduled contract change
     * Reverse one schedule change: the cancelled original version becomes ACTIVE again for its full period, and the two versions the change created (the cut copy named by versionId and the version that follows it) are removed together with their payers. versionId is the CUT COPY, not the change version. If a non-cancelled invoice covers the original's period the undo is blocked (422) so the caller can cancel those invoices and retry.
     * @param versionId Contract Version ID (the cut copy)
     * @returns billing_ContractVersionResponse OK
     * @throws ApiError
     */
    public static postApiV1ContractsVersionsUndoChange(
        versionId: string,
    ): CancelablePromise<billing_ContractVersionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/versions/{versionId}/undo-change',
            path: {
                'versionId': versionId,
            },
            errors: {
                400: `Invalid request`,
                401: `Unauthenticated`,
                403: `Organization ID or user ID not found in token`,
                404: `Version not found`,
                422: `Undo rejected by a precondition or blocked by a non-cancelled invoice`,
                500: `Undo failed`,
            },
        });
    }
}
